import axios from 'axios'
// import Vuetify from 'vuetify'

/**
 * Per accedere globalmente a questo modulo usare rootState, rootGetters negli altri moduli
 * 
 * Esempio:
 * getters: {
 *  getRoute(state, getters, rootState) {
 *    return rootState.route;
 *   }
 * }
 */

export default {
	namespaced: true,
	
	state: {
		clientiIds: {
			default: null,
			valueNonApplied: null,
			value: null
		},
		esitoClickDay: {
			default: null,
			valueNonApplied: null,
			value: null
		},
		dataScadenzaSaldoEsitiProvvisori: {
			default: null,
			valueNonApplied: null,
			value: null
		},
		dataScadenzaSaldoEsitiDefinitivi: {
			default: null,
			valueNonApplied: null,
			value: null
		},
	},

	getters: {
		clientiIds(state) {
			return state.clientiIds;
		},
		esitoClickDay(state) {
			return state.esitoClickDay;
		},
		dataScadenzaSaldoEsitiProvvisori(state) {
			return state.dataScadenzaSaldoEsitiProvvisori;
		},
		dataScadenzaSaldoEsitiDefinitivi(state) {
			return state.dataScadenzaSaldoEsitiDefinitivi;
		},
		defaultFilters(state) {
			let defaultFilters = {};
			for (let stateKey in state) {
				defaultFilters[stateKey] = state[stateKey].default;
			}
			return defaultFilters;
		},
		appliedFilters(state) {
			let appliedFilters = {};
			for (let stateKey in state) {
				appliedFilters[stateKey] = state[stateKey].value;
			}
			return appliedFilters;
		},
		thereAreFiltersApplied(state) {
			let thereAreFiltersApplied = false;
			for (let stateKey in state) {
				if (state[stateKey].value != state[stateKey].default) {
					thereAreFiltersApplied = true;
				}
			}
			return thereAreFiltersApplied;
		}
	},

	mutations: { // è il setter dello store, è sincrona, quindi meglio non usarla per fare chiamate api
		SET_CLIENTI_IDS_NON_APPLIED (state, value) {
			state.clientiIds.valueNonApplied = value;
		},
		SET_CLIENTI_IDS_TO_DEFAULT (state, value) {
			state.clientiIds.valueNonApplied = state.clientiIds.default;
			state.clientiIds.value = state.clientiIds.default;
		},
		SET_ESITO_CLICK_DAY_NON_APPLIED (state, value) {
			state.esitoClickDay.valueNonApplied = value;
		},
		SET_DATA_SCADENZA_SALDO_ESITI_PROVVISORI_NON_APPLIED (state, value) {
			state.dataScadenzaSaldoEsitiProvvisori.valueNonApplied = value;
		},
		SET_DATA_SCADENZA_SALDO_ESITI_DEFINITIVI_NON_APPLIED (state, value) {
			state.dataScadenzaSaldoEsitiDefinitivi.valueNonApplied = value;
		}
	},

	actions: { // sono asincrone, posso fare chiamate api e richiamare poi la mutation
		applyFilters({ state }) { // applica i filtri che vengono passati ad axios in ContrattiDiServizioDataTable
			for (let stateKey in state) {
				state[stateKey].value = state[stateKey].valueNonApplied;
			}
		},
		resetFilters({ state }) {
			for (let stateKey in state) {
				state[stateKey].value = state[stateKey].default;
				state[stateKey].valueNonApplied = state[stateKey].default;
			}
		}
	}
}

// export default {
// 	namespaced: true,
// 	state,
// 	getters,
// 	mutations,
// 	actions
// }